import React from 'react'

import { CurveUploadDialogProps } from './constants'
import CurvePriceUploadTemplateUrl from './assets/CurvePriceUploadTemplate.xlsx'
import { NegotiationsUploadToolbar } from '../NegotiationsUploadToolbar'
import { Locale, Translation } from 'locale'

export const CurveNegotiationsToolbar: React.FC = () => {
  return (
    <NegotiationsUploadToolbar
      uploadDialogProps={CurveUploadDialogProps}
      templateUrl={CurvePriceUploadTemplateUrl}
      templateLabel={Locale.translate(Translation.TC_DOWNLOAD_CURVE_TEMPLATE_FILENAME)}
    />
  )
}
